/* jshint ignore:start */
import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import './index.css';

import 'material-components-web/dist/material-components-web.min.css';

const EvmToStellar = lazy(() => import('./pages/EvmToStellar'));
const StellarToEvm = lazy(() => import('./pages/StellarToEvm'));
const Token = lazy(() => import('./pages/TokenPage'));

function App() {
    return (
        <Suspense fallback={<div style={{ padding: 24 }}>Loading…</div>}>
            <Routes>
                <Route path="/" element={<Token />} />
                <Route path="/evm-to-stellar" element={<EvmToStellar />} />
                <Route path="/stellar-to-evm" element={<StellarToEvm />} />
            </Routes>
        </Suspense>
    );
}

export default App;
/* jshint ignore:end */
